const Config = {
    name: 'nl.spoordeelwinkel'
};

export default Config;
